import { UpdateCurrentUserPassword } from 'smg/customer-api/currentuser';
import * as errors from 'smg/errors';
import { ReportValidity } from 'smg/form';
import { AccountReady } from '../account-session';

void main();

async function main() {
    if (await AccountReady) {
        return;
    }

    const form = document.querySelector('#change-password-form') as HTMLFormElement;

    const newPassword = document.querySelector('#new-password') as HTMLInputElement;
    const confirmPassword = document.querySelector('#confirm-password') as HTMLInputElement;

    const checkConfirm = () => {
        if (newPassword.value === confirmPassword.value) {
            confirmPassword.setCustomValidity('');
        } else {
            confirmPassword.setCustomValidity('Passwords must match');
        }
    };

    newPassword.addEventListener('input', () => checkConfirm());
    confirmPassword.addEventListener('input', () => checkConfirm());

    const success = document.querySelector('#password-change-success') as HTMLElement;
    success.parentElement?.removeChild(success);
    success.classList.remove('d-none');

    const titleHeader = document.querySelector('#title-header');

    form.noValidate = true;
    form.addEventListener('submit', e => {
        e.preventDefault();

        if (!ReportValidity(form)) {
            return false;
        }

        UpdateCurrentUserPassword({
            newPassword: newPassword.value,
            confirmPassword: confirmPassword.value,
        }).
            then(() => {
                newPassword.value = '';
                confirmPassword.value = '';

                titleHeader?.after(success.cloneNode(true));
            }).
            catch(err => errors.ShowError(err, form));
    });
}